import { Directive, OnInit, Input, ElementRef } from '@angular/core';
declare var $: any;
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'scrollable'
})
export class ScrollableDirective implements OnInit {

  @Input() public height: number;
  public defaultHeight = 250;

  constructor(public element: ElementRef) { }

  public ngOnInit() {
    $(this.element.nativeElement).slimScroll({
      height: (this.height || this.defaultHeight)
    });
  }

}
